<template>
  <aha-dropdown class="top-4">
    <aha-dropdown-items
      v-if="currentUser.rememberSettings"
      @hide="$emit('togglePresentOptions')"
      :visible="showPresentOptions"
      class="z-20 rounded-lg shadow min-w-80 p-1"
      right
    >
      <aha-input-group class="px-4">
        <aha-multi-tabs
          @onChangeTab="onChangeTab"
          :tabTitles="tabs"
          :defaultTabIndex="activeTab"
        >
        </aha-multi-tabs>
      </aha-input-group>
      <PresentTabContent
        v-if="activeTab === PRESENT_TAB"
        @togglePresentOptions="$emit('togglePresentOptions')"
        @handlePresentMenuClick="(item) => $emit('handlePresentMenuClick', item)"
      />
      <KeepAlive>
        <RemoteControlContent
          v-if="activeTab === REMOTE_CONTROL_TAB"
          class="p-3"
          :presentation="presentation"
          :source="'Present button'"
        />
      </KeepAlive>
    </aha-dropdown-items>
  </aha-dropdown>
</template>

<script>
import EditorHeaderPresentButton from '@/components-v2/presentation-editor/editor-header/EditorHeaderPresentButton.vue'
import PresentTabContent from '@/components-v2/presentation-editor/editor-header/EditorHeaderPresentButton/PresentTabContent.vue'
import RemoteControlContent from '@/components-v2/presentation-editor/editor-header/EditorHeaderPresentButton/RemoteControlContent.vue'

const PRESENT_TAB = 0
const REMOTE_CONTROL_TAB = 1

export default {
  components: {
    PresentTabContent,
    RemoteControlContent,
  },
  extends: EditorHeaderPresentButton,
  data: () => ({
    activeTab: PRESENT_TAB,
    tabs: ['Present', 'Remote control (Beta)'],
    PRESENT_TAB,
    REMOTE_CONTROL_TAB,
  }),
  methods: {
    onChangeTab(index) {
      this.activeTab = index
    },
  },
}
</script>
